module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"add":"Hinzufügen","addCustomer":"Kunde hinzufügen","back":"Zurück","pleaseCompleteTheForm":"Bitte vervollständigen Sie Ihre Angaben."},"en":{"add":"Add","addCustomer":"Add customer","back":"Back","pleaseCompleteTheForm":"Please complete the form."}}')
  delete Component.options._Ctor
}
